import { ExpertiseService } from "@/common/api.service";
import {
  FETCH_EXPERTISES,
  FETCH_EXPERTISES_LIST,
  FETCH_ALL_EXPERTISES_LIST,
  FETCH_EXPERTISE_DETAILS
} from "./actions.type";
import {
  FETCH_ALL_EXPERTISES_END,
  FETCH_ALL_EXPERTISES_START,
  FETCH_EXPERTISES_END,
  FETCH_EXPERTISES_START,
  SET_EXPERTISE_DETAILS
} from "@/store/mutations.type";

const state = {
  expertise: {},
  isExpLoading: false,
  expertises: [],
  isAllExpLoading: false,
  allExpertises: [],
  currentExpertise: null
};

const getters = {
  expertise() {
    return state.expertise;
  },
  isExpLoading() {
    return state.isExpLoading;
  },
  expertises() {
    return state.expertises;
  },
  isAllExpLoading() {
    return state.isAllExpLoading;
  },
  allExpertises() {
    return state.allExpertises;
  },
  currentExpertise: state => state.currentExpertise
};

const actions = {
  async [FETCH_EXPERTISES]({ state }, id) {
    await ExpertiseService.list(id)
      .then(({ data }) => {
        state.expertise = data;
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [FETCH_EXPERTISES_LIST]({ commit }, params) {
    commit(FETCH_EXPERTISES_START);
    return ExpertiseService.getListExpertises(params)
      .then(({ data }) => {
        commit(FETCH_EXPERTISES_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [FETCH_ALL_EXPERTISES_LIST]({ commit }, params) {
    commit(FETCH_ALL_EXPERTISES_START);
    return ExpertiseService.getListAllExpertises(params)
      .then(({ data }) => {
        commit(FETCH_ALL_EXPERTISES_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [FETCH_EXPERTISE_DETAILS]({ commit }, { projectId, expertiseId }) {
    try {
      const { data } = await ExpertiseService.getExpertiseDetails(
        projectId,
        expertiseId
      );
      commit(SET_EXPERTISE_DETAILS, data);
    } catch (error) {
      throw new Error(error);
    }
  }
};

const mutations = {
  [FETCH_EXPERTISES_START](state) {
    state.isExpLoading = true;
  },
  [FETCH_EXPERTISES_END](state, expertises) {
    state.expertises = expertises;
    state.isExpLoading = false;
  },
  [FETCH_ALL_EXPERTISES_START](state) {
    state.isAllExpLoading = true;
  },
  [FETCH_ALL_EXPERTISES_END](state, expertises) {
    state.allExpertises = expertises;
    state.isAllExpLoading = false;
  },
  [SET_EXPERTISE_DETAILS](state, expertiseDetails) {
    state.currentExpertise = expertiseDetails;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
